import { SignInPage } from '@backstage/core-components';
import {
  createFrontendModule,
  googleAuthApiRef,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

const googleProvider = {
  id: 'google-auth-provider',
  title: 'Google',
  message: 'Sign in with your journey.travel Google account',
  apiRef: googleAuthApiRef,
};

// Local development has no Google client, so it keeps guest sign-in.
const providers =
  process.env.NODE_ENV === 'development'
    ? ['guest' as const]
    : [googleProvider];

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => props =>
          <SignInPage {...props} providers={providers} />,
      },
    }),
  ],
});
